import { observer } from "mobx-react";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Form, Segment,Header,Button,Grid  } from "semantic-ui-react";
import { AddressFormBody, LocationModel } from "../../../../components/address";
import { IIDCardModel } from "../../../../components/idcard/IDCardModel";
import IDCardReaderProfile from "../../../../components/idcard/IDCardReaderProfile";
import {
  MarriageStatusType,
  OccupationInfoForm,
  RegistedAddressCurrentType,
  RegistedAddressType,
  RelationshipType,
  ResidenceStatusType,
  ResidenceType,
} from "../../components";
import { IRequestItemModel } from "../RequestModel";

interface IRequestFormInfoGuarantor extends WithTranslation {
  requestItems: IRequestItemModel;
  idCardItem: IIDCardModel;
  documentDate: string;
  idCardSpouseItems: IIDCardModel;
  requestType?: string;
}

@observer
class RequestFormInfoGuarantor extends React.Component<IRequestFormInfoGuarantor> {
  public state = { showResult: false };
  public _isMounted = false;
  public locationRegisteredAddressStore = LocationModel.create({});
  public locationCurrentAddressStore = LocationModel.create({});
  public locationGuarantorCompanyAddressStore = LocationModel.create({});
  public componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.locationRegisteredAddressStore.loadSubdistrict(
          this.props.requestItems.guarantor.registeredAddress.subDistrict
        );
        this.locationRegisteredAddressStore.loadDistrict(this.props.requestItems.guarantor.registeredAddress.district);
        this.locationRegisteredAddressStore.loadProvince(this.props.requestItems.guarantor.registeredAddress.province);
        this.locationCurrentAddressStore.loadSubdistrict(this.props.requestItems.guarantor.currentAddress.subDistrict);
        this.locationCurrentAddressStore.loadDistrict(this.props.requestItems.guarantor.currentAddress.district);
        this.locationCurrentAddressStore.loadProvince(this.props.requestItems.guarantor.currentAddress.province);
        this.locationGuarantorCompanyAddressStore.loadSubdistrict(
          this.props.requestItems.guarantorCompanyAddress.subDistrict
        );
        this.locationGuarantorCompanyAddressStore.loadDistrict(
          this.props.requestItems.guarantorCompanyAddress.district
        );
        this.locationGuarantorCompanyAddressStore.loadProvince(
          this.props.requestItems.guarantorCompanyAddress.province
        );
      }
    }, 2000);
  }
  public componentWillUnmount() {
    this._isMounted = false;
  }
  public render() {
    const { requestItems, t, idCardItem, documentDate,idCardSpouseItems,requestType } = this.props;
    return (
      <Segment padded style={styles.bg}>
        {idCardItem ? (
          <IDCardReaderProfile
            displayMode="full"
            idCardReadingStore={idCardItem}
            profile={requestItems.guarantor}
            address={requestItems.guarantor.idCardAddress}
            noSegment
            fieldname="gurantor"
            calculateAgeDate={documentDate}
            requestCheck={true}
          />
        ) : null}

        <Form.Field
          label={t("module.loan.requestDetail.status")}
          width={16}
          control={MarriageStatusType}
          inputFieldMarriageStatus="marriageStatus"
          valueFieldMarriageStatus={requestItems.guarantor.marriageStatus}
          onChangeInputField={this.onChangeInputFieldBorrower}
        />

      {[1].includes(requestItems.guarantor.marriageStatus) ? (
          <Segment padded style={styles.segment}>
               <Form.Field>
            <label>{t("module.loan.requestDetail.spouseInfo")}</label>
             <IDCardReaderProfile
              displayMode="simple"
              idCardReadingStore={idCardSpouseItems}
              profile={requestItems.guarantorSpouse}
              address={requestItems.guarantorSpouse.idCardAddress}
              fieldname="guarantorSpouse"
              calculateAgeDate={documentDate}
            />
            {/* <Button
              id="btn-submit-check-borrow"
              floated="right"
              color="blue"
              onClick={this.onVerifySpouse}
            >
              {t("module.loan.requestDetail.checkBasicQualificationsSpouse")}
            </Button> */}
            </Form.Field>
            <Grid stackable>
          <Grid.Row verticalAlign="middle">
            <Grid.Column textAlign="center">
              <Header
                size="large"
                color={requestItems.guarantorSpouse.isVerify ? "green" : "red"}
                style={
                  requestItems.guarantorSpouse.isVerify
                    ? styles.isVerify
                    : styles.headerMarginBottom
                }
              >
                  {requestItems.guarantorSpouse.isVerify && this.state.showResult
                     ? t("ข้อมูลคู่สมรสผ่านคุณสมบัติ")
                     : this.state.showResult ?
                     t("ข้อมูลคู่สมรสไม่ผ่านคุณสมบัติ") :null}
              </Header>
              {requestItems.guarantorSpouse.error.message ? (
                <Header
                  size="small"
                  color={"red"}
                  style={styles.headerMarginTop}
                >
                  {requestItems.guarantorSpouse.error.message}
                </Header>
              ) : null}

              {/* <Button fluid color="blue" basic onClick={this.reCheck}>
                {t("module.loan.requestDetail.checkAgain")}
              </Button> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
          </Segment>
        ): null}
        <Form.Field
          label={t("module.loan.agreementFormCreate.houseAddress")}
          width={16}
          control={RegistedAddressType}
          inputFieldAddressType="registeredAddressType"
          valueFieldAddressType={requestItems.guarantor.registeredAddressType}
          onChangeInputField={this.onChangeInputFieldRegisteredAddressType}
        />
        {requestItems.guarantor.registeredAddressType === 99 ? (
          <Form.Field
            label={t("module.loan.agreementDetail.addressDetailsAccordingToHouseRegistration")}
            width={16}
            control={AddressFormBody}
            addressStore={requestItems.guarantor.registeredAddress}
            locationStore={this.locationRegisteredAddressStore}
          />
        ) : null}
        {requestItems.checkCompareProvince? (
              <Header color="red">
                {t(
                  "module.loan.guaranteeDetail.checkHouseRegistration"
                )}
              </Header>
            ) : null}
        <Form.Field
          label={t("module.loan.agreementDetail.currentAddress")}
          width={16}
          control={RegistedAddressCurrentType}
          inputFieldCurrentAddressType="currentAddressType"
          valueFieldCurrentAddressType={requestItems.guarantor.currentAddressType}
          onChangeInputField={this.onChangeInputFieldCurrentAddressType}
          address={requestItems.guarantor.currentAddress}
        />
        {requestItems.guarantor.currentAddressType === 99 ? (
          <Form.Field
            label={t("module.loan.agreementDetail.currentAddressDetails")}
            width={16}
            control={AddressFormBody}
            addressStore={requestItems.guarantor.currentAddress}
            locationStore={this.locationCurrentAddressStore}
          />
        ) : null}

        <Form.Field
          label={t("module.loan.agreementDetail.housingtType")}
          width={16}
          control={ResidenceType}
          inputFieldResidenceType="residenceType"
          valueFieldResidenceType={requestItems.guarantor.residenceType}
          inputFieldDescription="residenceTypeDescription"
          valueFieldDescription={requestItems.guarantor.residenceTypeDescription}
          onChangeInputField={this.onChangeInputFieldBorrower}
        />
        <Form.Field
          required
          label={t("module.loan.agreementDetail.livingStatus")}
          width={16}
          id={"request-form-info-guarantor-residence-status-type"}
          control={ResidenceStatusType}
          inputFieldStatusType="residenceStatusType"
          valueFieldStatusType={requestItems.guarantor.residenceStatusType}
          inputFieldDescription="residenceStatusTypeDescription"
          valueFieldDescription={requestItems.guarantor.residenceStatusTypeDescription}
          valueFieldAddressType={requestItems.guarantor.registeredAddressType}
          onChangeInputField={this.onChangeInputFieldBorrower}
        />
        <Form.Field
          label={t("module.loan.agreementDetail.relationsWithBorrowers")}
          width={16}
          control={RelationshipType}
          inputFieldRelationshipType="guarantorBorrowerRelationship"
          valueFieldRelationshipType={requestItems.guarantorBorrowerRelationship}
          onChangeInputField={this.onChangeInputField}
        />
        <Form.Field
          label={t("module.loan.components.occupation")}
          width={16}
          control={OccupationInfoForm}
          occupation={requestItems.guarantor.occupation}
          inputFieldCompanyName="guarantorCompanyName"
          inputFieldPosition="guarantorPosition"
          valueFieldCompanyName={requestItems.guarantorCompanyName}
          valueFieldPosition={requestItems.guarantorPosition}
          onChangeInputField={this.onChangeInputField}
          requestType={requestType}
        />
        <Form.Field
          label={t("module.loan.agreementDetail.companyAddress")}
          width={16}
          control={AddressFormBody}
          addressStore={requestItems.guarantorCompanyAddress}
          locationStore={this.locationGuarantorCompanyAddressStore}
        />
        <Form.Input
          fluid
          label={t("module.loan.agreementDetail.officePhoneNumber")}
          placeholder={t("module.loan.agreementFormCreate.specifyPhoneNumber")}
          onChange={(event: any, data: any) => {
            if (isNaN(data.value)) {
              return;
            }
            requestItems!.setField({
              fieldname: "guarantorCompanyTelephone",
              value: data.value,
            });
          }}
          value={requestItems.guarantorCompanyTelephone}
        />
        <Form.Input
          required
          fluid
          label={t("module.loan.agreementFormCreate.telephoneNumber")}
          placeholder={t("module.loan.agreementFormCreate.specifyPhoneNumber")}
          onChange={(event: any, data: any) => {
            if (isNaN(data.value)) {
              return;
            }
            requestItems.guarantor.setField({
              fieldname: "telephone",
              value: data.value,
            });
          }}
          value={requestItems.guarantor.telephone}
        />
        <Form.Input
          fluid
          label={t("module.loan.agreementDetail.mobilePhoneNumber")}
          placeholder={t("module.loan.agreementDetail.enterMobilePhoneNumber")}
          onChange={(event: any, data: any) => {
            if (isNaN(data.value)) {
              return;
            }
            requestItems.guarantor.setField({
              fieldname: "mobilePhone",
              value: data.value,
            });
          }}
          value={requestItems.guarantor.mobilePhone}
        />
      </Segment>
    );
  }
  private onChangeInputFieldRegisteredAddressType = (fieldname: string, value: any) => {
    const { requestItems } = this.props;
    requestItems.guarantor.setField({ fieldname, value });
  };
  private onChangeInputFieldCurrentAddressType = (fieldname: string, value: any) => {
    const { requestItems } = this.props;
    requestItems.guarantor.setField({ fieldname, value });
  };
  private onChangeInputFieldBorrower = (fieldname: string, value: any) => {
    const { requestItems } = this.props;
    requestItems.guarantor.setField({ fieldname, value });
  };
  private onChangeInputField = (fieldname: string, value: any) => {
    const { requestItems } = this.props;
    requestItems.setField({ fieldname, value });
  };
  private renderResult() {
    const { requestItems, t } = this.props;
    return (
      <Segment placeholder>
        <Grid stackable>
          <Grid.Row verticalAlign="middle">
            <Grid.Column textAlign="center">
              <Header
                size="large"
                color={requestItems.guarantorSpouse.isVerify ? "green" : "red"}
                style={
                  requestItems.guarantorSpouse.isVerify
                    ? styles.isVerify
                    : styles.headerMarginBottom
                }
              >
                {requestItems.guarantorSpouse.isVerify
                  ? t("module.loan.requestDetail.canFileLoan")
                  : t("module.loan.requestDetail.unableFileLoan")}
              </Header>
              {requestItems.guarantorSpouse.error.message ? (
                <Header
                  size="small"
                  color={"red"}
                  style={styles.headerMarginTop}
                >
                  {requestItems.guarantorSpouse.error.message}
                </Header>
              ) : null}

              <Button fluid color="blue" basic onClick={this.reCheck}>
                {t("module.loan.requestDetail.checkAgain")}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
  private onVerifySpouse = async () => {
    const { requestItems} = this.props;
    try {
      await requestItems.guarantorSpouse.error.resetAll();
      await requestItems.guarantorSpouse.requestsVerifySpouse(requestItems.guarantorSpouse.idCardNo);
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({ showResult: true });
    }
  };
  private reCheck = async () => {
    const { requestItems } = this.props;
    try {
      await requestItems.guarantorSpouse.error.resetAll();
      await requestItems.guarantorSpouse.setField({
        fieldname: "isVerify",
        value: false
      });
      await this.setState({ showResult: false });
    } catch (e) {
      console.log(e);
    }
  };
}

const styles: any = {
  bg: {
    backgroundColor: "rgba(242, 113, 28,0.3)",
  },
  segment: {
    paddingBottom: 50
  },
  headerMarginBottom: {
    marginBottom: 0
  },
  headerMarginTop: {
    marginTop: 0
  },
  isVerify: {
    marginBottom: 14
  }
};
export default withTranslation()(RequestFormInfoGuarantor);
